module.exports = __webpack_public_path__ + "static/media/close_icon.52a8446e.svg";